/* tslint:disable */
/* eslint-disable */
/**
 * Portfolio-Optimizer
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EnrichedAsset } from './EnrichedAsset';
import {
    EnrichedAssetFromJSON,
    EnrichedAssetFromJSONTyped,
    EnrichedAssetToJSON,
} from './EnrichedAsset';

/**
 * 
 * @export
 * @interface EnrichedAssetPage
 */
export interface EnrichedAssetPage {
    /**
     * 
     * @type {Array<EnrichedAsset>}
     * @memberof EnrichedAssetPage
     */
    assets: Array<EnrichedAsset>;
    /**
     * 
     * @type {number}
     * @memberof EnrichedAssetPage
     */
    totalNr: number;
    /**
     * 
     * @type {string}
     * @memberof EnrichedAssetPage
     */
    asOfDate: string;
}

/**
 * Check if a given object implements the EnrichedAssetPage interface.
 */
export function instanceOfEnrichedAssetPage(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "assets" in value;
    isInstance = isInstance && "totalNr" in value;
    isInstance = isInstance && "asOfDate" in value;

    return isInstance;
}

export function EnrichedAssetPageFromJSON(json: any): EnrichedAssetPage {
    return EnrichedAssetPageFromJSONTyped(json, false);
}

export function EnrichedAssetPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrichedAssetPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'assets': ((json['assets'] as Array<any>).map(EnrichedAssetFromJSON)),
        'totalNr': json['total_nr'],
        'asOfDate': json['as_of_date'],
    };
}

export function EnrichedAssetPageToJSON(value?: EnrichedAssetPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'assets': ((value.assets as Array<any>).map(EnrichedAssetToJSON)),
        'total_nr': value.totalNr,
        'as_of_date': value.asOfDate,
    };
}

